import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Button, Stack, Typography } from "@mui/material";
import {
  LayoutContainer,
  LayoutHeader,
  LayoutWrapper,
} from "../components/layout";
import { userLoggedSelector } from "../state/selectors/sessionSelectors";
import { STORE_ID_DEFAULT } from "../constants/businessValues";
import LoadingContext from "../context/LoadingProvider";
import StoreService from "../services/StoreService";
import PersonIcon from "@mui/icons-material/Person";
import CartIcon from "@mui/icons-material/Shop";
import "../components/card/styles.css";
import { cartActiveSelector } from "../state/selectors/cartSelectors";
import CartService from "../services/CartService";
import { cleanCart, observerCartActive } from "../state/actions";

export const Entrance = () => {
  const { setLoadingValue } = useContext(LoadingContext);
  const userLogged = useSelector(userLoggedSelector);
  const navigation = useNavigate();
  const cartActive = useSelector(cartActiveSelector);
  const dispatch = useDispatch();

  const goToCart = () => navigation("/cart");

  // Evaluacion principal que activa el get de productos
  const evaluationCart = () => {
    CartService.getOrderActive(userLogged.login).then((response) => {
      if (response instanceof Error) {
        dispatch(observerCartActive(false));
        return;
      } else {
        dispatch(observerCartActive(response[0]?.length > 0));
      }
    });
  };

  const selectPersons = async () => {
    setLoadingValue(true);
    StoreService.enterStore(userLogged.login, STORE_ID_DEFAULT, "2", "in")
      .then((res: any) => {
        const response = JSON.parse(res.result);
        if (response.msg === "OK") {
          navigation("/verify-entrance", { state: { res: res.result } });
        } else {
          toast(response.msg);
        }
      })
      .catch(() => toast("Error al abrir tienda"))
      .finally(() => setLoadingValue(false));
  };

  useEffect(() => {
    evaluationCart();
  }, []);

  useEffect(() => {
    if (!cartActive) {
      dispatch(cleanCart());
    }
  }, [cartActive]);

  return (
    <LayoutContainer>
      <LayoutWrapper>
        <LayoutHeader>
          <Stack spacing={2} style={style.stack}>
            <Typography color="white" variant="h6">
              Ingreso a la tienda
            </Typography>

            <Button
              onClick={selectPersons}
              style={style.usersAccess}
              variant="outlined"
              fullWidth
              startIcon={<PersonIcon style={style.iconPerson} />}
            >
              Ingresar a la tienda
            </Button>

            {cartActive && (
              <Button
                onClick={goToCart}
                style={style.usersAccess}
                variant="outlined"
                fullWidth
                startIcon={<CartIcon style={style.iconPerson} />}
              >
                Ir al carrito
              </Button>
            )}
          </Stack>

          <Button
            onClick={() => navigation("/")}
            variant="outlined"
            style={style.cardBtn}
            fullWidth
          >
            VOLVER
          </Button>
        </LayoutHeader>
      </LayoutWrapper>
    </LayoutContainer>
  );
};

const style: any = {
  usersAccess: {
    padding: 3,
    borderRadius: "10px",
    borderColor: "white",
    borderWidth: 1,
    borderStyle: "dashed",
    width: "100%",
  },
  iconPerson: {
    fontSize: 40, // ajusté tamaño para que quede más balanceado
    color: "white",
  },
  stack: {
    alignItems: "center",
    textAlign: "center",
    justifyContent: "space-between",
  },
  cardBtn: {
    textDecoration: "none",
    boxShadow: "none",
    marginTop: 20,
  },
};
